
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.336-5.431a3.35 3.35 0 112.682 6.132l-.02.007a.75.75 0 00-.5.75.75.75 0 01-1.497.085 2.25 2.25 0 011.489-2.246 1.85 1.85 0 10-2.142-2.844.75.75 0 01-1.195-.906 3.35 3.35 0 011.183-.978zM12.75 17a.75.75 0 10-1.5 0v.01a.75.75 0 101.5 0V17z"}})])
          )
        }
      }
    